// extracted by mini-css-extract-plugin
export var form = "styles-module--form--nk8q4";
export var label = "styles-module--label--ip05y";
export var input = "styles-module--input--hzEnk";
export var submit = "styles-module--submit--J2wC6";